"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mon332TreatmentSelector = exports.mon332ParamSelector = exports.mon279ParamSelector = exports.mon307IsVariantSelector = exports.mon307TtsPurchaseMotionType = exports.mon307TtsStyleSelector = exports.mon307TreatmentSelector = exports.mon317IsContentForwardSelector = exports.mon317TreatmentSelector = exports.mon245ShowTaglineSelector = exports.isExperimentTreatmentRequestLoadingSelector = exports.experimentParameterSelector = exports.experimentTreatmentSelector = void 0;

var _laboratoryLib = require("laboratory-lib");

var _ExperimentConstants = require("pricing-pages-unified-ui/constants/ExperimentConstants");

var _PurchaseMotionSelectors = require("pricing-pages-unified-ui/selectors/PurchaseMotionSelectors");

var _PurchaseMotionsLocations = require("pricing-pages-unified-ui/constants/PurchaseMotionsLocations");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _PurchaseMotionTypes = require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes");

var _ConfigSelectors = require("./ConfigSelectors");

var _MarketingContactsSelectors = require("./MarketingContactsSelectors");

var experimentTreatmentSelector = function experimentTreatmentSelector(_ref, treatmentKey) {
  var treatments = _ref.experimentTreatments.treatments;
  if (!treatments) return null;
  return (0, _laboratoryLib.getTreatment)(treatments, treatmentKey);
};

exports.experimentTreatmentSelector = experimentTreatmentSelector;

var experimentParameterSelector = function experimentParameterSelector(state, treatmentKey, parameterKey) {
  var treatment = experimentTreatmentSelector(state, treatmentKey);
  return (0, _laboratoryLib.getParameter)(treatment, parameterKey);
};

exports.experimentParameterSelector = experimentParameterSelector;

var isExperimentTreatmentRequestLoadingSelector = function isExperimentTreatmentRequestLoadingSelector(_ref2) {
  var isLoading = _ref2.experimentTreatments.isLoading;
  return isLoading;
};

exports.isExperimentTreatmentRequestLoadingSelector = isExperimentTreatmentRequestLoadingSelector;

var mon245ShowTaglineSelector = function mon245ShowTaglineSelector(state) {
  var publicShowTagline = experimentParameterSelector(state, 'public-pricing-page-monetization-245p', 'show-tagline').value === 'true';
  var authedShowTagline = experimentParameterSelector(state, 'pricing-page-monetization-245', 'show-tagline').value === 'true';
  return publicShowTagline || authedShowTagline;
};

exports.mon245ShowTaglineSelector = mon245ShowTaglineSelector;

var mon317TreatmentSelector = function mon317TreatmentSelector(state) {
  return experimentTreatmentSelector(state, _ExperimentConstants.MON317_TREATMENT_KEY);
};

exports.mon317TreatmentSelector = mon317TreatmentSelector;

var mon317IsContentForwardSelector = function mon317IsContentForwardSelector(state) {
  var pageDesignParameter = experimentParameterSelector(state, _ExperimentConstants.MON317_TREATMENT_KEY, _ExperimentConstants.MON317_PAGE_DESIGN_PARAMETER);
  return pageDesignParameter.value === _ExperimentConstants.MON317_PAGE_DESIGN_OPTIONS.CONTENT_FORWARD;
};

exports.mon317IsContentForwardSelector = mon317IsContentForwardSelector;

var mon307TreatmentSelector = function mon307TreatmentSelector(state) {
  return experimentTreatmentSelector(state, _ExperimentConstants.MON307_TREATMENT_KEY);
};

exports.mon307TreatmentSelector = mon307TreatmentSelector;

var mon307TtsStyleSelector = function mon307TtsStyleSelector(state) {
  var override = localStorage.getItem('cbx:mon307override');

  if (override && Object.values(_ExperimentConstants.MON307_TTS_STYLE_OPTIONS).includes(override)) {
    return override;
  }

  var parameter = experimentParameterSelector(state, _ExperimentConstants.MON307_TREATMENT_KEY, _ExperimentConstants.MON307_TTS_STYLE_PARAMETER);
  return parameter && parameter.value || _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.CONTROL;
};

exports.mon307TtsStyleSelector = mon307TtsStyleSelector;

var mon307TtsPurchaseMotionType = function mon307TtsPurchaseMotionType(state, hub) {
  var highlightedMerch = _HubMap.default[hub].highlightedPaidMerch;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = highlightedMerch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var merchId = _step.value;
      if ((0, _PurchaseMotionSelectors.purchaseMotionsSelector)(state, _PurchaseMotionsLocations.EXTENDED_MERCH_CARD, merchId).includes(_PurchaseMotionTypes.TALK_TO_SALES)) return _PurchaseMotionTypes.TALK_TO_SALES;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return _PurchaseMotionTypes.TALK_TO_SALES_FALLBACK;
};

exports.mon307TtsPurchaseMotionType = mon307TtsPurchaseMotionType;

var mon307IsVariantSelector = function mon307IsVariantSelector(state) {
  return mon307TtsStyleSelector(state) !== _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.CONTROL;
};

exports.mon307IsVariantSelector = mon307IsVariantSelector;

var mon279ParamSelector = function mon279ParamSelector(state) {
  // Show MC Beta users the control experience so we don't clash experiment experience with MC Beta experience
  // Although this experiment is auto-exposure logged, we will filter out MC Beta users in analysis
  if ((0, _MarketingContactsSelectors.isInMCBetaSelector)(state)) return 'control';
  var publicParam = experimentParameterSelector(state, 'growth-cbx-279p', 'display');
  var authedParam = experimentParameterSelector(state, 'growth-cbx-279', 'display');
  var paramToUse = (0, _ConfigSelectors.isAppAuthSelector)(state) ? authedParam : publicParam;
  return paramToUse.value || 'control';
};

exports.mon279ParamSelector = mon279ParamSelector;

var mon332ParamSelector = function mon332ParamSelector(state) {
  var isInMCBeta = (0, _MarketingContactsSelectors.isInMCBetaSelector)(state);
  if (isInMCBeta) return 'true'; // Exclude from experiment while MC beta is running

  var publicParam = experimentParameterSelector(state, 'growth-cbx-332p', 'show-popup');
  var authedParam = experimentParameterSelector(state, 'growth-cbx-332', 'show-popup');
  var paramToUse = (0, _ConfigSelectors.isAppAuthSelector)(state) ? authedParam : publicParam;
  return paramToUse.value || 'true';
};

exports.mon332ParamSelector = mon332ParamSelector;

var mon332TreatmentSelector = function mon332TreatmentSelector(state) {
  var treatmentKey = (0, _ConfigSelectors.isAppAuthSelector)(state) ? 'growth-cbx-332' : 'growth-cbx-332p';
  return experimentTreatmentSelector(state, treatmentKey);
};

exports.mon332TreatmentSelector = mon332TreatmentSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ExperimentTreatmentSelectors.js
// module id = 89
// module chunks = 5 6